module.exports = __webpack_public_path__ + "img/c7fb3e4.jpg";